import React from "react";
import TrendingProducts from "../components/TrendingProducts";
import { Link } from "react-router-dom";
import {
  HiOutlineArrowRight,
  HiOutlineLightningBolt,
  HiOutlineShieldCheck,
  HiOutlineTruck,
} from "react-icons/hi";
import { FaCoins } from "react-icons/fa";

function Dashboard() {
  return (
    <div className="bg-[#0b0e14] text-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden min-h-[90vh] flex items-center bg-[url('https://images.unsplash.com/photo-1542751371-adc38448a05e?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center">
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent z-0"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10 w-full">
          <div className="lg:max-w-3xl">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-cyan-500/10 border border-cyan-500/30 text-cyan-400 text-[10px] font-black tracking-[0.3em] uppercase mb-8">
              <span className="w-2 h-2 bg-cyan-400 rounded-full animate-ping"></span>
              Operation: Upgrade 2026
            </span>
            <h1 className="text-5xl sm:text-7xl lg:text-9xl font-black leading-none tracking-tighter mb-8 uppercase italic">
              Level Up Your <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-600">
                Performance.
              </span>
            </h1>
            <p className="text-lg text-gray-400 mb-12 max-w-xl leading-relaxed font-bold uppercase tracking-wide">
              Equip yourself with the industry's most powerful gaming hardware.
              Precision engineered for champions.
            </p>
            <div className="flex flex-col sm:flex-row gap-6">
              <Link
                to="/catalog"
                className="group relative bg-cyan-500 text-black px-10 py-5 rounded-xl font-black uppercase tracking-widest text-sm flex items-center justify-center gap-3 hover:bg-cyan-400 transition-all shadow-[0_0_30px_rgba(0,242,255,0.3)] over:shadow-[0_0_50px_rgba(0,242,255,0.5)]"
              >
                Assemble Gear{" "}
                <HiOutlineArrowRight className="text-xl group-hover:translate-x-2 transition-transform" />
              </Link>
              <Link
                to="/catalog"
                className="bg-transparent border-2 border-white/20 hover:border-white px-10 py-5 rounded-xl font-black uppercase tracking-widest text-sm flex items-center justify-center gap-3 hover:bg-white/5 transition-all text-white"
              >
                Intel / Database
              </Link>
            </div>
          </div>
        </div>

        {/* Decor */}
        <div className="absolute bottom-10 left-10 hidden lg:flex items-center gap-10">
          <div className="flex flex-col">
            <span className="font-black text-cyan-400 text-3xl">0.03ms</span>
            <span className="text-[10px] text-gray-500 uppercase font-black">
              Latency
            </span>
          </div>
          <div className="flex flex-col">
            <span className="font-black text-purple-400 text-3xl">
              Unlimited
            </span>
            <span className="text-[10px] text-gray-500 uppercase font-black">
              Potential
            </span>
          </div>
        </div>
      </section>

      {/* Features Bar */}
      <section className="bg-black/40 border-y border-white/5 py-12 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              {
                title: "Warp Delivery",
                desc: "Arrives in 24 hours",
                icon: <HiOutlineTruck />,
                color: "cyan",
              },
              {
                title: "Secure Shell",
                desc: "Military-grade protect",
                icon: <HiOutlineShieldCheck />,
                color: "purple",
              },
              {
                title: "24/7 Support",
                desc: "Real-time engineers",
                icon: <HiOutlineLightningBolt />,
                color: "blue",
              },
            ].map((f, i) => (
              <div key={i} className="flex items-center gap-6 group">
                <div
                  className={`w-14 h-14 rounded-2xl border border-white/10 flex items-center justify-center text-3xl group-hover:scale-110 transition-transform bg-white/5`}
                >
                  {f.icon}
                </div>
                <div>
                  <h3 className="font-black uppercase tracking-widest text-sm mb-1">
                    {f.title}
                  </h3>
                  <p className="text-xs text-gray-500 font-bold uppercase">
                    {f.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Categories */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-20 gap-8">
            <div className="text-center md:text-left">
              <h2 className="text-4xl lg:text-6xl font-black uppercase italic tracking-tighter mb-4">
                Select Your{" "}
                <span className="text-cyan-400 tracking-tighter">Class</span>
              </h2>
              <p className="text-gray-500 font-black uppercase tracking-widest text-xs">
                Filter by specialized hardware categories.
              </p>
            </div>
            <Link
              to="/catalog"
              className="px-8 py-3 rounded-full bg-white/5 border border-white/10 text-[10px] font-black uppercase tracking-[0.3em] hover:bg-white/10 transition-all text-gray-400 hover:text-white"
            >
              System Browse
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                name: "PCs",
                img: "https://images.unsplash.com/photo-1593640408182-31c70c8268f5?q=80&w=2042&auto=format&fit=crop",
              },
              {
                name: "Consoles",
                img: "https://images.unsplash.com/photo-1605906302474-f60dfcod44cc?q=80&w=2070&auto=format&fit=crop",
              },
              {
                name: "Controllers",
                img: "https://images.unsplash.com/photo-1592840331052-16e15c2c6f95?q=80&w=2050&auto=format&fit=crop",
              },
              {
                name: "Headphones",
                img: "https://images.unsplash.com/photo-1546435770-a3e426bf472b?q=80&w=2065&auto=format&fit=crop",
              },
            ].map((cat, i) => (
              <Link
                key={i}
                to={`/catalog?category=${cat.name}`}
                className="group relative h-96 rounded-[2rem] overflow-hidden border border-white/10 hover:border-cyan-400/50 transition-all"
              >
                <img
                  src={cat.img}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                  alt={cat.name}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent z-10"></div>
                <div className="absolute bottom-8 left-8 right-8 z-20">
                  <h3 className="text-white font-black text-2xl uppercase tracking-tighter mb-2 italic">
                    {cat.name}
                  </h3>
                  <span className="text-cyan-400 text-[10px] font-black uppercase tracking-[0.2em] flex items-center gap-2 group-hover:gap-4 transition-all opacity-0 group-hover:opacity-100">
                    Initialize <HiOutlineArrowRight />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Credits Promo Banner */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto bg-gradient-to-br from-[#1a1f28] to-[#0b0e14] border border-white/10 rounded-[3rem] p-12 lg:p-20 relative overflow-hidden shadow-2xl">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-[120px]"></div>

          <div className="flex flex-col lg:flex-row items-center justify-between gap-12 relative z-10">
            <div className="text-center lg:text-left lg:max-w-2xl">
              <div className="inline-flex items-center gap-3 bg-cyan-400/10 border border-cyan-400/20 px-4 py-2 rounded-xl text-cyan-400 text-[10px] font-black uppercase tracking-[0.3em] mb-8">
                Reward Protocol Alpha
              </div>
              <h2 className="text-4xl lg:text-6xl font-black text-white mb-6 uppercase tracking-tighter italic">
                Earn{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-500">
                  Gamer Pts
                </span>{" "}
                <br />
                With Every Drop
              </h2>
              <p className="text-gray-400 text-lg font-bold uppercase tracking-wide">
                Purchase store credits today and receive massive hardware
                bonuses. Stack Pts to unlock legendary builds.
              </p>
            </div>
            <Link
              to="/credits"
              className="group flex items-center gap-4 bg-white text-black px-12 py-6 rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-cyan-400 transition-all shadow-xl hover:-translate-y-2"
            >
              <FaCoins className="text-2xl animate-spin-slow" />
              Recharge Pts
              <HiOutlineArrowRight className="text-xl group-hover:translate-x-2 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* Trending / Featured */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-24">
            <span className="text-purple-500 font-extrabold uppercase tracking-[0.5em] text-[10px] mb-4 block">
              Hot Drops
            </span>
            <h2 className="text-5xl lg:text-7xl font-black text-white mb-6 uppercase italic tracking-tighter">
              Trending <span className="text-purple-500">Hardware</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-purple-600 mx-auto rounded-full shadow-[0_0_15px_rgba(0,242,255,0.5)]"></div>
          </div>
          <TrendingProducts />
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
